// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__WFrfl","compact":"button_compact__G5kma","suffix":"button_suffix__0X7F5","roundButton":"button_roundButton__xs7vB"};